import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import styleClasses from '../css/mobile/Footer.module.scss';

const Footer = () => {
  const [showBusiness, setShowBusiness] = useState(true);
  const location    = useLocation();
  const currentPath = location.pathname;
  const pathArray   = currentPath.split("/");

  useEffect(() => {
    if (pathArray[1]) {
      if (pathArray[1] === 'musicard' && pathArray.length > 2) {
        setShowBusiness(false);
      } else {
        setShowBusiness(true);
      }
    } else {
      setShowBusiness(true);
    }
  }, [pathArray])

  return (
    <footer className={ styleClasses.footerMobile }>
      <div className={styleClasses.content}>
        <div className={`${ styleClasses.info } ${ !showBusiness && styleClasses.hidden }`}>
          {/* Business Info */}
          <div className={ styleClasses.eachInfo }>
            <div className={ styleClasses.inner }>
              <div className={ styleClasses.row }>
                <p>상호명</p>
                <p>뮤지직 Musizic</p>
              </div>
              <div className={ styleClasses.row }>
                <p>대표자명</p>
                <p>김예원</p>
              </div>
              <div className={ styleClasses.row }>
                <p>사업자번호</p>
                <p>627-37-01417</p>
              </div>
              <div className={ styleClasses.row }>
                <p>문의</p>
                <Link to="mailto:contact@musizic.com" className={ styleClasses.email }>
                  contact@musizic.com
                </Link>
              </div>
            </div>
          </div>
          {/* 사이트맵
          <div className={ styleClasses.eachInfo }>
            <div className={ styleClasses.inner }>
              <div className={ styleClasses.row }>
                <Link to='/'>Home</Link>
              </div>
              <div className={ styleClasses.row }>
                <Link to='/musicard'>Musicard</Link>
              </div>
              <div className={ styleClasses.row }>
                <Link to='/about-us'>About Us</Link>
              </div>
            </div>
          </div>
          */}
          {/* SNS Links */}
          <div className={ styleClasses.eachInfo }>
            <div className={ styleClasses.inner }>
              <div className={ styleClasses.row }>
                <Link to="https://www.youtube.com/@musizic.official" target="_blank" rel="noopener noreferrer" className={ styleClasses.link }>
                  <img src="/assets/icons/youtube-icon.png" alt="YouTube" />
                </Link>
                <Link to="https://www.instagram.com/musizic/" target="_blank" rel="noopener noreferrer" className={ styleClasses.link }>
                  <img src="/assets/icons/instagram-icon.png" alt="Instagram" />
                </Link>
                <Link to="https://www.threads.net/@musizic" target="_blank" rel="noopener noreferrer" className={ styleClasses.link }>
                  <img src="/assets/icons/thread-icon.png" alt="Threads" />
                </Link>
                <Link to="https://x.com/musizic" target="_blank" rel="noopener noreferrer" className={ styleClasses.link }>
                  <img src="/assets/icons/x-icon.png" alt="X (Twitter)" />
                </Link>
                <Link to="https://blog.naver.com/musizic" target="_blank" rel="noopener noreferrer" className={ styleClasses.link }>
                  <img src="/assets/icons/naver blog-icon.png" alt="Naver Blog" />
                </Link>
                <Link to="https://open.kakao.com/o/gDFpRN6g" target="_blank" rel="noopener noreferrer" className={ styleClasses.link }>
                  <img src="/assets/icons/kakao opentalk-icon.png" alt="Kakao Opentalk" />
                </Link>
              </div>
            </div>
          </div>
          {/* More Info */}
          <div className={ styleClasses.eachInfo }>
            <div className={ styleClasses.inner }>
              <div className={`${ styleClasses.row } ${ styleClasses.column }`}>
                <Link to="/TermsOfService">이용약관</Link>
                <Link to="/PrivacyPolicy">개인정보처리방침</Link>
                <Link to="https://forms.gle/645Kf9Dq9M7kYLhCA">오류보고 및 제안</Link>
                <Link to="https://prismcst.notion.site/1b5ad564822680f0978dd6d47d192a98?pvs=4">어파드팀 소개</Link>
              </div>
            </div>
          </div>
          {/* More Info */}
          {/* <div className={ styleClasses.eachInfo }>
            <div className={ styleClasses.inner }>
              <div className={ styleClasses.about }>
                <p><Link to="/TermsOfService">이용약관</Link></p>
                <p><Link to="/PrivacyPolicy">개인정보처리방침</Link></p>
                <p><Link to="https://forms.gle/645Kf9Dq9M7kYLhCA">오류보고 및 제안</Link></p>
              </div>
            </div>
          </div>*/}
        </div>
        {/* Footer Copyright */}
        <div className={ styleClasses.copyright }>
          <p>© 2025 Musizic. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
